import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import state from './state'
import moduleMotivateMonitorWorkshop from '../../submodules/motivateMonitorWorkshop'

const moduleWorkshops = {
  namespaced: true,
  state () {
    return state
  },
  actions: actions,
  mutations: mutations,
  getters: getters,
  modules: {
    motivateMonitor: moduleMotivateMonitorWorkshop
  }
}

export default moduleWorkshops



// WEBPACK FOOTER //
// ./src/vuex/modules/workshops/workshops.js